export const numberMasking = (number: string | number, visibleNumbers: number = 4) => {
  const stringedNumber = (number || "")?.toString();

  return `${'*'.repeat(stringedNumber.slice(0, -visibleNumbers).length)}${stringedNumber.slice(-visibleNumbers)}`
}